<div class="row">
  <bitf-dnd-file (dropFiles)="onFileDropped($event)"
    *ngIf="showDndArea"
    class="col-12">
    <div class="col-auto">
      {{ 'FILE_UPLOADER.DROP_FILES_HERE_OR_SELECT' | translate }} </div>
    <div class="col-auto">
      <button mat-stroked-button
        color="primary"
        (click)="selectFile.click()"> {{ 'FILE_UPLOADER.SELECT_FILE' | translate | uppercase }}
      </button>
      <input class="d-none"
        type="file"
        #selectFile
        [attr.multiple]="(maxNumberOfFiles > 1) ? '' : null"
        (change)="onFileDropped($event)" />
    </div>
  </bitf-dnd-file>
  <div class="col-12 d-flex align-items-center justify-content-center">
    <button mat-stroked-button
      color="primary"
      (click)="selectFolder.click()"> {{ 'FILE_UPLOADER.SELECT_FOLDER' | translate | uppercase }}
    </button>
    <input webkitdirectory
      directory
      class="d-none"
      type="file"
      #selectFolder
      (change)="onFileDropped($event)" />
  </div>
</div>

<div class="my-2"
  *bitfUiRoleManager="{action: ERoleActions.OVERRIDE_FILE, mode: ERoleMode.HIDDEN, data: {fsStore: fsStore}}">
  <mat-checkbox [(ngModel)]="overrideFile"
    color="primary">
    {{'FILE_UPLOADER.OVERRIDE_FILE' | translate}} </mat-checkbox>
</div>

<div *ngIf="!showDndArea">
  <button mat-stroked-button
    color="primary"
    (click)="imgFileInput.click()">
    <mat-icon class="mr-2">cloud_upload</mat-icon> {{ 'FILE_UPLOADER.UPLOAD' | translate | uppercase }}
  </button>
  <input type="file"
    class="d-none"
    #imgFileInput
    [attr.multiple]="(maxNumberOfFiles > 1) ? '' : null"
    (change)="onFileDropped($event)" />
</div>

<div *ngIf="files.length && showFileList"
  class="mt-3">
  <h3 class="mb-1">{{'FILE_UPLOADER.SELECETED_FILES' | translate}}</h3>

  <mat-list role="list"
    [ngClass]="{'file-list-scrollable': config.isScrollable}">
    <mat-list-item
      *bitfUiRoleManager="{action: ERoleActions.SHOW_TAG, mode: ERoleMode.HIDDEN, data: {fsStore: fsStore}}">
      <div class="row w-100 border-bottom">
        <div class="col-12 d-flex align-items-center">
          <mat-checkbox [(ngModel)]="useParentTags"
            [indeterminate]="useParentTags && fileThatUseParentTags < files.length"
            (change)="onParentTagToggleChange($event)"
            color="primary"
            class="mr-2">
          </mat-checkbox>
          {{'COMMON.LABEL.SELECTED' | translate}}: {{fileThatUseParentTags}}
        </div>
        <div class="col-6">
          <bitf-mat-form-option class="w-100 tag-select"
            [disabled]="isUploading"
            appearance="outline"
            matFormFieldClass="w-100 tag-select"
            [formOptions]="tagsFormItemsConfig"
            [useObject]="true"
            selectFormControlName="tags"
            [form]="form"></bitf-mat-form-option>
        </div>
      </div>
    </mat-list-item>
    <mat-list-item *ngFor="let file of files; let index = index;">
      <div class="row align-items-center w-100">
        <div class="col-12 d-flex align-items-center">
          <mat-checkbox [(ngModel)]="file.metaData.useParentTag"
            (change)="onFileTagsChange($event)"
            color="primary"
            class="mr-2"
            *bitfUiRoleManager="{action: ERoleActions.SHOW_TAG, mode: ERoleMode.HIDDEN, data: {fsStore: fsStore}}">
          </mat-checkbox>
          <!-- <mat-icon mat-list-icon>folder</mat-icon> -->
          <div class="d-flex flex-column justify-content-center overflow-hidden ml-1">
            <span class="d-block text-truncate">{{ file.fileObject.name }}</span>
            <span class="mat-caption">({{file.fileObject.size | bitfBytes}})</span>
          </div>
        </div>
        <div class="col-6 d-flex align-items-center">
          <mat-form-field appearance="outline"
            *bitfUiRoleManager="{action: ERoleActions.SHOW_TAG, mode: ERoleMode.HIDDEN, data: {fsStore: fsStore}}"
            color="primary"
            class="tag-select w-100">
            <mat-select [(ngModel)]="file.metaData._tags"
              [disabled]="isUploading"
              [multiple]="true">
              <mat-option *ngFor="let tag of tagsFormItemsConfig.options"
                color="primary"
                [value]="tag">
                {{tag.label}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col ml-auto overflow-hidden d-flex align-items-center justify-content-end">
          <mat-progress-bar class="w-100"
            *ngIf="!file.isUploaded && file.isValid && !file.hasUploadErrors"
            [mode]="(file.isProcessing) ? 'indeterminate': 'determinate'"
            [value]="file.uploadedPercentage"></mat-progress-bar>
          <span *ngIf="file.isUploaded"
            class="w-100 d-flex justify-content-end">{{'FILE_UPLOADER.UPLOADED' | translate}}</span>

          <button mat-icon-button
            *ngIf="!file.isUploading && !file.isProcessing && !file.isUploaded"
            class="col-auto"
            (click)="removeFile(index)">
            <mat-icon>delete</mat-icon>
          </button>

          <div class="d-flex align-items-center">
            <span *ngIf="file.hasUploadErrors"
              class="mr-2">{{'FILE_UPLOADER.UPLOAD_ERROR' | translate}}</span>
            <mat-icon *ngIf="file.validationErrors.length || file.hasUploadErrors"
              color="warn"
              [matTooltip]="file.validationErrorsTooltip">
              warning</mat-icon>
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
    </mat-list-item>
  </mat-list>

  <div *ngIf="fsStore.configuration.needsConfirm"
    class="my-3">
    <span class="d-block">{{'COMMON.LABEL.CHECK_TO_CONFIRM' | translate}}</span>
    <mat-checkbox [(ngModel)]="isUploadConfirmed"
      color="primary">
      {{'COMMON.LABEL.UPLOAD_CONFIRM' | translate}}
    </mat-checkbox>
  </div>

  <div class="d-flex justify-content-end prada-white-bg mt-3"
    *ngIf="!uploadOnFilesDropped">
    <button mat-button
      [disabled]="isUploading"
      (click)="removeAllFiles()"
      class="col-auto mr-2">
      {{ 'COMMON.BUTTON.REMOVE_FILE' | translate }}
    </button>

    <button mat-raised-button
      [disabled]="isUploading || !isUploadConfirmed"
      color="primary"
      (click)="upload()"
      class="col-auto">
      {{ 'FILE_UPLOADER.UPLOAD' | translate }}
    </button>
  </div>
</div>